<template>
    <v-layout align-center justify-center row wrap>
        <v-flex :xs11="icon" :xs12="!icon" class="pa-0 ma-0">

            <!--Route Alert-->
            <router-link v-if="route" :to="route">
                <w-span
                    :font-size="fontSize"
                    :font-weight="fontWeight"
                    :color="fontColor"
                >
                    {{ title}}
                </w-span>
            </router-link>

            <!--Array of titles-->
            <template v-else-if="$_.isArray(title)">
                <ul v-if="title && title.length > 1">
                    <li v-for="item in title" :key="item">
                        <w-span
                            :font-size="fontSize"
                            :font-weight="fontWeight"
                            :color="fontColor"
                        >
                            {{ item }}
                        </w-span>
                    </li>
                </ul>

                <w-span
                    v-else
                    :font-size="fontSize"
                    :font-weight="fontWeight"
                    :color="fontColor"
                >
                    {{ title[0] }}
                </w-span>
            </template>

            <!-- Default -->
            <w-span
                v-else
                :font-size="fontSize"
                :font-weight="fontWeight"
                :color="fontColor"
            >
                {{ title }}
            </w-span>
        </v-flex>

        <!--Icon right-->
        <v-flex xs1 class="pa-0 ma-0 text-xs-right" v-if="icon">
            <w-btn
                class="pa-0 ma-0"
                icon
                :icon-color="iconColor"
                :icon-name="icon"
                @click.native.stop="handleIconClick"
            ></w-btn>
        </v-flex>
    </v-layout>
</template>

<script>
    import WBtn from '../WBtn'

    export default {
        name: 'WAlertContent',
        props: {
            /**
             * Font size
             */
            fontSize: {
                type: String,
                default: 'subheading'
            },
            /**
             * Font Weight
             */
            fontWeight: {
                type: String,
                default: 'medium'
            },
            /**
             * Font color
             */
            fontColor: {
                type: String,
                default: 'white'
            },
            /**
             * title
             */
            title: {
                type: [String, Array],
                default: ''
            },
            /**
             * Icon to be displayed on the right
             */
            icon: {
                type: String,
                default: ''
            },
            /**
             * Icon color to be displayed on the right
             */
            iconColor: {
                type: String,
                default: 'accent'
            },
            /**
             * Route object
             */
            route: {
                type: [Object, Boolean],
                default: false
            }
        },
        components: {
            WBtn
        },
        methods: {
            handleIconClick () {
                /**
                 * Emit click event
                 * @event click
                 * @type {undefined}
                 */
                this.$emit('click')
            }
        }
    }
</script>
